import { atom } from "recoil";

export const paneStateExpanded = atom<boolean>({
  key: "paneStateExpanded",
  default: true,
});
